// Importaciones obligatorias de React.
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

//Importar dependencias y store de React Redux.
import { Provider } from 'react-redux';
import store from './store/store';

//Importar assets (recursos : hojas de estilo, imagenes, fuentes).
import './assets/css/app.css';
import './assets/css/login/login.css';

//Inicio CSS.
import './assets/css/inicio/inicio.css';
import './assets/css/inicio/navigation.css';
import './assets/css/inicio/sidebar.css';
import './assets/css/inicio/outlet.css';

//Remates CSS.
import './assets/css/remates/remates.css';
import './assets/css/remates/cardClient.css';
import './assets/css/remates/tableClients.css';



//Inbox CSS.
import './assets/css/chats/chats.css';
import './assets/css/chats/inbox_styles/inbox.css';
import './assets/css/chats//inbox_styles/local_components_styles/chatInInbox.css';
import './assets/css/chats//inbox_styles/local_components_styles/messageTimeInInbox.css';
import './assets/css/chats//inbox_styles/local_components_styles/messageByTypeInInbox.css';
import './assets/css/chats//inbox_styles/local_components_styles/listChats.css';

//Chats CSS.
import './assets/css/chats/chat_styles/chat.css';
import './assets/css/chats/chat_styles/bodyChat.css';
import './assets/css/chats/chat_styles/headerChat.css';
import './assets/css/chats/chat_styles/local_components_styles/menu.css';
import './assets/css/chats/chat_styles/local_components_styles/messageTypeImageInChat.css';
import './assets/css/chats/chat_styles/local_components_styles/unselectedchat.css';
import './assets/css/chats/chat_styles/local_components_styles/newfilemessage.css';
import './assets/css/chats/chat_styles/local_components_styles/session.css';
import './assets/css/chats/chat_styles/local_components_styles/defaultmessage.css';
import './assets/css/chats/chat_styles/local_components_styles/menusendfile.css';
import './assets/css/chats/chat_styles/local_components_styles/previewfileselected.css';
import './assets/css/chats/chat_styles/local_components_styles/draggingview.css';
import './assets/css/chats/chat_styles/local_components_styles/sessionHeader.css';
import './assets/css/chats/chat_styles/local_components_styles/messagebytypeInChat.css';
import './assets/css/chats/chat_styles/local_components_styles/messageInChat.css';
import './assets/css/chats/chat_styles/local_components_styles/sessiondurationinfo.css';
import './assets/css/chats/chat_styles/local_components_styles/writeMessage.css';
import './assets/css/chats/chat_styles/local_components_styles/btnSendMessage.css';

//Client Profile CSS.
import './assets/css/chats/clientProfile_styles/clientprofile.css';
import './assets/css/chats/clientProfile_styles/multimedia.css';

//Loading CSS.
import './assets/css/loading.css';

//Responsividad CSS.
import './assets/css/responsive.css'

//Componentes Comunes
import './assets/css/common/btnborder.css';
import './assets/css/common/burbujas.css';
import './assets/css/common/btnGetMoreChats.css';
import './assets/css/common/searcher.css';
import './assets/css/common/operatorUserAvatar.css';
import './assets/css/common/btnScrollBottom.css';
import './assets/css/common/lpchatLogo.css';
import './assets/css/common/btnCompany.css';
import './assets/css/common/userProfileWithRol.css';
import './assets/css/common/btnChangeModeTheme.css';
import './assets/css/common/chatsTitleWithNumber.css';
import './assets/css/common/computerWithLogo.css';
import './assets/css/common/menuUserProfile.css';
import './assets/css/common/modalMessageResolutions.css';
import './assets/css/common/modalMessageFileSize.css';
import './assets/css/common/modalCreateNewPassword.css';
import './assets/css/common/tabFilter.css';
import './assets/css/common/imageWithZoomCursor.css';
import './assets/css/common/loadingChatsPreview.css';
import './assets/css/common/autoAsingSwitch.css';
import './assets/css/common/modal/modalActiveSessionsList.css';
 


//Cargar configuración react time ago.
import TimeAgo from 'javascript-time-ago';
import es from 'javascript-time-ago/locale/es.json';

TimeAgo.addDefaultLocale(es);
TimeAgo.addLocale(es);


// Arrancar app de react
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>

    <App />
    </Provider>
);

